/* =============================================================================
   AMERICAN TRUFFLE CO — DUAL NAVIGATION: ZONE LINK REWRITER
   File: assets/atc-dual-nav.js

   Ensures all /blogs/news links carry the correct ?z= parameter so visitors
   stay in their current zone (growers or buyers) when clicking blog links
   generated by Shopify templates, blog content, pagination, breadcrumbs, etc.

   Loaded with defer in layout/theme.liquid before </body>:
     <script src="{{ 'atc-dual-nav.js' | asset_url }}" defer></script>
   ============================================================================= */

(function () {
  'use strict';

  // ── Read current zone from the header element ──────────────────────────
  var header = document.querySelector('sht-header[data-nav-zone]');
  if (!header) return;

  var zone = header.getAttribute('data-nav-zone');

  // Only rewrite when we're in an audience zone
  if (zone !== 'growers' && zone !== 'buyers') return;

  var zParam = zone === 'buyers' ? 'z=buyers' : 'z=growers';

  // ── Rewrite function ──────────────────────────────────────────────────
  function rewriteLinks(root) {
    var links = (root || document).querySelectorAll('a[href*="/blogs/news"]');

    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var href = a.getAttribute('href');

      // Skip if no href or already has ?z=
      if (!href) continue;
      if (href.indexOf('z=growers') !== -1 || href.indexOf('z=buyers') !== -1) continue;

      // Parse the URL to check the pathname starts with /blogs/news
      var pathname;
      try {
        var url = new URL(href, window.location.origin);
        if (url.origin !== window.location.origin) continue;
        pathname = url.pathname;
      } catch (e) {
        pathname = href.split('?')[0].split('#')[0];
      }

      if (pathname.indexOf('/blogs/news') !== 0) continue;

      // Append the z parameter, respecting existing query strings and hashes
      var hashIndex = href.indexOf('#');
      var hash = '';
      var base = href;

      if (hashIndex !== -1) {
        hash = href.substring(hashIndex);
        base = href.substring(0, hashIndex);
      }

      if (base.indexOf('?') !== -1) {
        base = base + '&' + zParam;
      } else {
        base = base + '?' + zParam;
      }

      a.setAttribute('href', base + hash);
    }
  }

  // ── Initial pass on page load ─────────────────────────────────────────
  rewriteLinks(document);

  // ── Observe dynamically added content (AJAX pagination, etc.) ─────────
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType === 1) {
            // Check the node itself
            if (node.tagName === 'A' && node.getAttribute('href') &&
                node.getAttribute('href').indexOf('/blogs/news') !== -1) {
              rewriteLinks(node.parentNode);
            }
            // Check children
            if (node.querySelectorAll) {
              var inner = node.querySelectorAll('a[href*="/blogs/news"]');
              if (inner.length > 0) {
                rewriteLinks(node);
              }
            }
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // ── Also re-run on Shopify section render events (Theme Editor) ───────
  if (typeof document.addEventListener === 'function') {
    document.addEventListener('shopify:section:load', function (e) {
      rewriteLinks(e.target);
    });
  }

})();